<template>
  <div class="exam-container">
    <el-row :gutter="15" class="exam-list" v-if="showtype == 1">
      <el-col :span="6" v-for="(item, i) in examlist" :key="item.id">
        <div :class="{ 'exam-item': 1, active: active === i }" @click="clickItem(i)">
          <div class="top">
            <img :src="item.cover_url" alt="" />
            <el-button v-if="
                item.examStatus === '已结束' || item.examStatus === '进行中'
              " type="primary" plain size="mini" @click="methodExamResult(item)">阅卷评分</el-button>
          </div>
          <div class="title">
            <el-tooltip :content="item.title" placement="top-start">
              <span>{{ item.title }}</span>
            </el-tooltip>
          </div>
          <div class="content">
            <!-- <div class="desc">
              <span>试题数量 11</span>
              <span>总分 100</span>
            </div> -->
            <div class="creator">创建人 {{ item.realname }}</div>
            <div class="create-time">考试时间 {{ item.start_date }}</div>
            <div class="end-time">结束时间 {{ item.end_date }}</div>
            <!-- 统计 -->
            <div class="statistics">
              <span>考试时长: {{ item._lasttime }}分钟</span>
              <span>及格: {{ item.passscore }}</span>
              <span>提交情况: {{ item.finished_num }}/{{
                  item.stu_total_num
                }}</span>
            </div>
            <div class="status-operation">
              <div class="status">
                <el-tag size="mini" :type="
                    item.examStatus === '进行中'
                      ? 'warning'
                      : item.examStatus === '已结束'
                      ? 'danger'
                      : ''
                  ">{{ item.examStatus }}</el-tag>
              </div>
              <div class="operation">
                <el-button type="text" size="mini" @click="methodEditExam(item)" icon="el-icon-edit-outline">编辑考试</el-button>
                <el-button type="text" size="mini" @click="methoddeleteExam(item.id)" icon="el-icon-delete">删除</el-button>
                <el-button type="text" size="mini" @click="methodaddExamStu(item)" icon="el-icon-view">查看考生</el-button>
              </div>
            </div>
          </div>
          <div class="detail" v-if="item.paperInfo">
            <div class="detail-title">
              <!-- <el-tooltip :content="item.paperInfo.title" placement="top-start">
                <span>{{ item.paperInfo.title }}</span>
              </el-tooltip> -->

              <el-button type="primary" :plain="!item.isKept" size="mini" :disabled="!item.allowSubmit" @click="methodCollectExam(item,i)" :data-ref="`collect_${i}`" :ref="`collect_${i}`" :icon="item.isKept?'el-icon-star-on':'el-icon-star-off'" class="collect">收藏试卷</el-button>
              <strong>总分: {{ item.paperInfo.total_score }}</strong>
            </div>
            <div class="line"></div>
            <el-tooltip placement="top-start">
              <div slot="content">
                <div v-for="paperQuestion in item.paperQuestionCountInfo" :key="paperQuestion.type">
                  {{ paperQuestionLabel(paperQuestion) }}
                  <p style="height: 5px;"></p>
                </div>
              </div>
              <div class="questionNum">
                <span class="questionNum-item" v-for="paperQuestion in item.paperQuestionCountInfo" :key="paperQuestion.type">{{ paperQuestionLabel(paperQuestion) }}</span>
              </div>
            </el-tooltip>
            <div class="management">
              <el-button type="text" size="mini" @click="methodEditQuestions(item)">
                <img src="../components/img/icon/management@2x.png" alt="" />
                <span>
                  试题管理
                </span>
              </el-button>
              <el-button type="text" size="mini" @click="methodLookExam(item)">
                <img src="../components/img/icon/preview@2x.png" alt="" />
                <span>
                  试卷预览
                </span>
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row v-if="showtype == 2">
      <el-col :span="24">
        <div>
          <el-table style="border-radius: 5px;" ref="examlist" :data="examlist" :header-cell-style="{
              background: 'white',
              color: '#606266',
              'font-size': '14px',
            }" stripe>
            <el-table-column align="center" width="50" label="序号">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 + page_size * (page_no - 1) }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" width="100" label="封面">
              <template slot-scope="scope">
                <el-image style="width: 40px; height: 18px" :src="scope.row.cover_url" fit="fill"></el-image>
                <!-- <el-image v-else style="width: 40px; height: 18px" :src="image" fit="fill"></el-image> -->
              </template>
            </el-table-column>

            <el-table-column width="200" align="left" prop="title" label="考试名称" :show-overflow-tooltip="true">
              <!-- <template slot-scope="scope">
            <el-link class="quest_btn" type="primary" @click="LookExam(scope.row)">{{ scope.row.title }}</el-link>
          </template> -->
            </el-table-column>

            <el-table-column width="100" align="center" label="总分" prop="paperInfo.total_score">
            </el-table-column>
            <el-table-column width="100" align="center" label="题数" prop="paperInfo.total_num">
            </el-table-column>
            <el-table-column width="150" align="center" label="考试时长(分钟)">
              <template slot-scope="scope">
                <span>{{ scope.row.lasttime / 60 }}</span>
              </template>
            </el-table-column>

            <el-table-column width="100" align="center" label="及格分数">
              <template slot-scope="scope">
                <span>{{ scope.row.passscore }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="提交情况">
              <template slot-scope="scope">
                <span>{{ scope.row.finished_num }} /
                  {{ scope.row.stu_total_num }}</span>
              </template>
            </el-table-column>

            <el-table-column width="200" align="left" label="开始时间" prop="start_date">
            </el-table-column>

            <el-table-column width="200" align="left" label="结束时间" prop="end_date">
            </el-table-column>

            <el-table-column align="left" label="创建人" prop="realname">
            </el-table-column>

            <el-table-column align="center" label="操作" fixed="right" width="180">
              <template slot-scope="scope">
                <!-- <el-link class="quest_btn" type="primary" @click="addExamStu(scope.row)">查看学员</el-link>

            <el-link class="quest_btn" type="primary" @click="ExamResult(scope.row)">成绩统计</el-link> -->

                <el-button @click="methodEditExam(scope.row)" type="text" size="mini">编辑</el-button>
                <el-button @click="methodExamResult(scope.row)" type="text" size="mini">阅卷评分</el-button>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多
                    <i class="el-icon-arrow-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="methodCollectExam(scope.row)">收藏试卷</el-dropdown-item>
                    <el-dropdown-item @click.native="methodaddExamStu(scope.row)">查看考生</el-dropdown-item>

                    <el-dropdown-item @click.native="methodEditQuestions(scope.row)">试题管理</el-dropdown-item>

                    <el-dropdown-item @click.native="methodLookExam(scope.row)">试卷预览</el-dropdown-item>
                    <el-dropdown-item @click.native="methoddeleteExam(scope.row.id)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'subunitExam',
  props: ['examlist', 'showtype', 'page_no', 'page_size'],
  data: () => ({
    active: -1,
    collectTimer: null
  }),
  computed: {
    paperQuestionLabel() {
      return function (paperQuestion) {
        return `
              ${paperQuestion.type === 1
            ? '单选题'
            : paperQuestion.type === 2
              ? '多选题'
              : paperQuestion.type === 3
                ? '判断题'
                : paperQuestion.type === 4
                  ? '填空题'
                  : paperQuestion.type === 5
                    ? '简答题'
                    : paperQuestion.type === 6
                      ? '综合题'
                      : paperQuestion.type === 7
                        ? '阅读程序题'
                        : paperQuestion.type === 8
                          ? '完善程序题'
                          : paperQuestion.type === 9
                            ? '编程题'
                            : '未识别题型'
          }: ${paperQuestion.QuestionTypeCount}`
      }
    },
  },
  methods: {
    methodCopyExam(item) {
      this.$emit('methodCopyExam', item)
    },
    methodCollectExam(item, i) {
      const target = this.$refs[`collect_${i}`][0].$el;
      // console.log(target.querySelector('i'));
      target.querySelector('i').style.animation = 'bounce 1s ease forwards'
      clearTimeout(this.collectTimer);
      this.collectTimer = setTimeout(() => {
        target.querySelector('i').style.animation = 'initial'
      }, 1000)
      this.$emit('methodCollectExam', item)
    },
    methodEditExam(item) {
      this.$emit('methodEditExam', item)
    },
    methodLookExam(item) {
      this.$emit('methodLookExam', item)
    },
    methoddeleteExam(id) {
      this.$emit('methoddeleteExam', id)
    },
    methodExamResult(item) {
      this.$emit('methodExamResult', item)
    },
    methodaddExamStu(item) {
      this.$emit('methodaddExamStu', item)
    },
    methodEditQuestions(item) {
      this.$emit('methodEditQuestions', item)
    },
    clickItem(i) {
      this.active = i
    },
  },
}
</script>
<style scoped lang="scss">
.exam-container {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .exam-list {
    display: flex;
    flex-wrap: wrap;

    .exam-item {
      // box-sizing: border-box;
      // width: 23.5%;
      position: relative;
      padding: 20px 15px 15px;
      margin-bottom: 20px;
      transition: box-shadow 0.2s;
      background: url("../components/img/paperIcon@2x.png") right top / 50%
        no-repeat;
      border-radius: 5px;
      background-color: #fff;
      &::before {
        position: absolute;
        left: -1px;
        top: -1px;
        width: 100%;
        height: 100%;
        content: "";
        display: block;
        border-radius: 5px;
        border: 1px solid transparent;
        transition: border-color 0.2s;
        pointer-events: none;
      }
      &:hover,
      &.active {
        box-shadow: 1px 0px 4px 0px #7591b8;
        &::before {
          border-color: #1678ff;
        }
      }
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        img {
          display: block;
          width: 50px;
          height: 50px;
          object-fit: cover;
          border-radius: 5px;
        }
        .el-button {
          height: 30px;
          background-color: #fff;
          color: #2c85ff;
          &:hover {
            color: #2c85ff;
          }
        }
      }
      .title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .content {
        padding: 15px 0px 0px;
        .desc {
          display: flex;
          align-items: center;
          padding-bottom: 10px;
          span {
            color: #2c85ff;
            &:first-child {
              margin-right: 25px;
            }
          }
        }
        .creator,
        .create-time,
        .end-time {
          padding-bottom: 5px;
          color: #666;
        }
        .statistics {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          width: 100%;
          padding: 5px 0 0;
          color: #333;
        }
        .status-operation {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .status {
            padding-top: 6px;
          }
          .operation {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            flex-wrap: wrap;
            padding-top: 10px;
            min-height: 46px;
            .el-button {
              padding: 0;
              margin-left: 7px;
              margin-bottom: 5px;
              color: #2c85ff;
              &:not(:first-child) {
                border-left: 1px solid #cbcbcb;
                padding-left: 7px;
              }
            }
            span {
              display: inline-flex;
              align-items: center;
              height: 12px;
              margin-left: 7px;
              margin-bottom: 5px;
              color: #2c85ff;
              &:not(:first-child) {
                border-left: 1px solid #cbcbcb;
                padding-left: 7px;
              }

              cursor: pointer;
            }
          }
        }
        /**
        @media screen and (max-width: 1600px) {
        }
        */
      }
      .detail {
        padding: 10px 15px 5px;
        background: #f7f9ff;
        // box-shadow: 0px 2px 4px 0px #93abcc;
        border-radius: 5px;
        .detail-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          // padding-bottom: 5px;
          font-weight: 400;
          font-size: 14px;
          color: #323233;
          line-height: 20px;
          // white-space: nowrap;
          // overflow: hidden;
          // text-overflow: ellipsis;
          strong {
            font-size: 12px;
          }
          // text-shadow: 0px 2px 4px #93abcc;
        }
        .line {
          padding: 8px 0px;
          &::after {
            content: "";
            display: block;
            margin: 0 auto;
            border-top: 1px dashed #eaeaea;
          }
        }
        .questionNum,
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          span.questionNum-item {
            padding-right: 10px;
            padding-bottom: 3px;
            font-size: 14px;
            color: #666;
            // &:nth-child(3n-1) {
            //   text-align: center;
            // }
            // &:nth-child(3n) {
            //   text-align: right;
            // }
          }
        }
        .management {
          display: flex;
          justify-content: flex-end;
          padding-top: 5px;
          .el-button {
            /deep/ span {
              display: inline-flex;
              align-items: center;
              color: #2c85ff;
            }
            img {
              height: 11px;
              margin-right: 3px;
            }
          }
        }
      }
    }
  }
}

.collect {
  /deep/ i {
    transition: transform 0.3s ease-out; /* 平滑过渡 */
  }
}
</style>
<style lang="scss">
/* 动画定义 */
@keyframes bounce {
  0% {
    transform: translateY(0) scale(1);
  }
  20% {
    /* 向下放大 */
    transform: translateY(5px) scale(1.5);
  }
  60% {
    /* 向上跳跃并旋转 */
    transform: translateY(-10px) scale(2) rotate(180deg);
  }
  100% {
    /* 回到原位 */
    transform: translateY(0) scale(1) rotate(360deg);
  }
}

/* 动画触发类 */
.animate-collect {
  animation: bounce 1s ease forwards;
}
</style>
